import { Text, Stack, Checkbox, Group, Mark } from '@mantine/core';
import { PortalButton } from 'components/Button/PortalButton';
import { GroupLabel } from 'components/GroupLabel';
import { useDeactivatePrescriptionsForm, DeactivePrescriptionsFormProvider } from 'context/FormContext';
import { useDrawerContext } from 'context/hooks';
import { useDeactivatePrescriptions } from 'hooks/api/prescription/useDeactivatePrescriptions';
import { Trans, useTranslation } from 'react-i18next';
import { PatientProfile } from 'utils/models';

interface DeactivationProps {
  patient: PatientProfile;
}

export const DeactivePrescription = ({ patient }: DeactivationProps) => {
  const { t } = useTranslation();
  const { mutate: deactivatePrescriptions } = useDeactivatePrescriptions();
  const { closeDrawer } = useDrawerContext();

  const form = useDeactivatePrescriptionsForm({
    initialValues: {
      groupIds: [],
      patient,
    },
  });

  const { values, onSubmit, getInputProps } = form;

  const handleFormSubmit = async () => {
    deactivatePrescriptions({ ...values });
    closeDrawer(false);
  };

  return (
    <DeactivePrescriptionsFormProvider form={form}>
      <form onSubmit={onSubmit(handleFormSubmit)}>
        <Stack align={'flex-start'}>
          <Text>
            <Trans
              i18nKey={'deactivate_prescription_text'}
              components={{
                mark: <Mark key={'markKey'} color={'white'} c={'var(--mantine-color-blue-5)'} />,
              }}
              values={{
                patient: `${patient.lastName} ${patient.firstName}`,
              }}
            />
          </Text>
          <Checkbox.Group {...getInputProps(`groupIds`)}>
            {patient.groups
              .filter((group) => !group.expired)
              .map((group) => (
                <Group key={group.id}>
                  <Checkbox value={group.id} />
                  <GroupLabel group={group} showDaysLeftLabel />
                </Group>
              ))}
          </Checkbox.Group>
          <PortalButton
            type={'submit'}
            label={t('confirm_label')}
            disabled={values.groupIds.length === 0}
            testId={'button-deactivate-prescription'}
          />
        </Stack>
      </form>
    </DeactivePrescriptionsFormProvider>
  );
};
